export const iconFontAwesomeMoneyShekelSign = (
	<i className="fa-solid fa-shekel-sign"></i>
);
